// This file allows us to lazily load the PanelsLabView component.
// Due to our configuration this needs to be in js so we can use dynamic imports.
export {default as PanelsLabView} from './PanelsLabView';
